

export default function getProducts(project, austattung_produkt, generatedProject){
    const matrix_rooms = [
        {product: "bat-geklebt-taster+", rooms: ["56b1b694-958d-4b4e-ae51-88967c88f8d9", "b8290c0e-368c-4747-a891-57ebb6fd0389", "56b1b694-958d-4b4e-ae51-88967c88f8d9"]},
        {product: "szenen", rooms: ["10f41afa-353f-4aac-bee2-874c5899e562"]},
        {product: "zeit-beleuchtung-aufsatz", rooms: ["46e3e159-d5a5-4623-9cd6-8f66f5fad7fa", "d8cf675b-2a77-42b9-8be7-5b9f7b6ff4f9", "46e3e159-d5a5-4623-9cd6-8f66f5fad7fa"]},
        {product: "dali-einsatz", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "smart-haus-iot", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "smart-haus-sprachsteuerung", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "smart-haus-jalousieaktor", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "smart-haus-zentrale-haussteuerung-fest", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "puck-wind", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "puck-sun", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "puck-rain", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "smart-haus-tueren-und-fenstern", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
        {product: "smart-haus-bedienstellen", rooms: ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"]},
    ];
    const cProducts = [];
    function getRoomForProduct(p) {
        const recommended = matrix_rooms.filter(i => i.product === p)[0];
        let foundRoom = generatedProject.floors[0].rooms[0];
        if (recommended) {
            generatedProject.floors.forEach(floor => {
                floor.rooms.forEach(room => {
                    if (recommended.rooms.includes(room.type)) { foundRoom = room; }
                });
            });
        }
        return foundRoom;
    }

    let productList = [];
    if (project.selectedEquipment["smart-haus-licht"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-licht"])
    ) {
        productList.push({
            product: austattung_produkt["bat-geklebt-taster+"],
            count: 1,
            room: getRoomForProduct("bat-geklebt-taster+")
        })
        productList.push({
            product: austattung_produkt["bat-geklebt-wippe"],
            count: 1,
            room: getRoomForProduct("bat-geklebt-taster+")
        })
    }
    if (project.selectedEquipment["smart-haus-aktor"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-aktor"])
    ) {
        if (project.selectedEquipment["smart-haus-aktor"] > 0) {
            productList.push({
                product: austattung_produkt["szenen"],
                count: 1,
                room: getRoomForProduct("szenen")
            })
        }
    }
    if (project.selectedEquipment["smart-haus-bewegung"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-bewegung"])
    ) {
        if (project.selectedEquipment["smart-haus-bewegung"] > 0) {
            productList.push({
                product: austattung_produkt["zeit-beleuchtung-aufsatz"],
                count: 1,
                room: getRoomForProduct("zeit-beleuchtung-aufsatz")
            })
            productList.push({
                product: austattung_produkt["scha-einsatz-1"],
                count: 1,
                room: getRoomForProduct("zeit-beleuchtung-aufsatz")
            })
        }
    }
    if (project.selectedEquipment["smart-haus-dali"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-dali"])
    ) {
        if (project.selectedEquipment["smart-haus-dali"] > 0) {
            if (project.subProjectType !== 'neubau') {
                productList.push({
                    product: austattung_produkt["dali-einsatz"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                productList.push({
                    product: austattung_produkt["einsatz-dali"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                productList.push({
                    product: austattung_produkt["wippe-dali"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                productList.push({
                    product: austattung_produkt["rahmen-dali"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                cProducts.push({
                    frame: austattung_produkt["r-1f"],
                    factor: 1,
                    insert: austattung_produkt["dali-einsatz"],
                    abdeckung: austattung_produkt["scha-aufsatz-1"],
                    room: getRoomForProduct("dali-einsatz")
                });
            } else {
                productList.push({
                    product: austattung_produkt["dali-einsatz-neubau"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                productList.push({
                    product: austattung_produkt["scha-aufsatz-2"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                productList.push({
                    product: austattung_produkt["r-1f"],
                    count: 1,
                    room: getRoomForProduct("dali-einsatz")
                })
                cProducts.push({
                    frame: austattung_produkt["r-1f"],
                    factor: 1,
                    insert: austattung_produkt["dali-einsatz"],
                    abdeckung: austattung_produkt["scha-aufsatz-1"],
                    room: getRoomForProduct("dali-einsatz")
                });
            }
        }
    }
    if (project.selectedEquipment["smart-haus-iot"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-iot"])
    ) {
        if (project.selectedEquipment["smart-haus-iot"] > 0) {
            const searched = productList.filter(i => i.product === austattung_produkt['iot']);
            if (!searched || searched.length === 0) {
                productList.push({
                    product: austattung_produkt["iot"],
                    count: 1,
                    room: getRoomForProduct("smart-haus-iot")
                })
                productList.push({
                    product: austattung_produkt["r-1f"],
                    count: 1,
                    room: getRoomForProduct("smart-haus-iot")
                })
            }
        }
    }
    if (project.selectedEquipment["smart-haus-sprachsteuerung"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-sprachsteuerung"])
    ) {
        if (project.selectedEquipment["smart-haus-sprachsteuerung"] > 0) {
            const searched = productList.filter(i => i.product === austattung_produkt['sprachsteuerung']);
            if (!searched || searched.length === 0) {
                productList.push({
                    product: austattung_produkt["sprachsteuerung"],
                    count: 1,
                    room: getRoomForProduct("smart-haus-sprachsteuerung")
                })
                productList.push({
                    product: austattung_produkt["r-1f"],
                    count: 1,
                    room: getRoomForProduct("smart-haus-sprachsteuerung")
                })
            }
        }
    }
    if (project.selectedEquipment["smart-haus-jalousieaktor"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-jalousieaktor"])
    ) {
        if (project.selectedEquipment["smart-haus-jalousieaktor"] > 0) {
            productList.push({
                product: austattung_produkt["jalousieaktor"],
                count: 1,
                room: getRoomForProduct("smart-haus-jalousieaktor")
            })
            // productList.push({
            //     product: austattung_produkt["r-1f"],
            //     count: 1,
            //     room: getRoomForProduct("smart-haus-jalousieaktor")
            // })
        }
    }
    if (project.selectedEquipment["smart-haus-zentrale-haussteuerung-fest"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-zentrale-haussteuerung-fest"])
    ) {
        if (project.selectedEquipment["smart-haus-zentrale-haussteuerung-fest"] > 0) {
            productList.push({
                product: austattung_produkt["iot"],
                count: 1,
                room: getRoomForProduct("smart-haus-zentrale-haussteuerung-fest")
            });
            productList.push({
                product: austattung_produkt["svServer"],
                count: 1,
                room: getRoomForProduct("smart-haus-zentrale-haussteuerung-fest")
            });
            productList.push({
                product: austattung_produkt["smartControl"],
                count: 1,
                room: getRoomForProduct("smart-haus-zentrale-haussteuerung-fest")
            });
            productList.push({
                product: austattung_produkt["netzTeil"],
                count: 1,
                room: getRoomForProduct("smart-haus-zentrale-haussteuerung-fest")
            });
        }
    }
    console.log('project', project)
    if (project.selectedEquipment["smart-haus-tueren-und-fenstern"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-tueren-und-fenstern"])
    ) {
        if (project.selectedEquipment["smart-haus-tueren-und-fenstern"] > 0) {
            project.floors.forEach(floor => {
                floor.rooms.forEach(room => {
                    console.log('parsing room', room.name)
                    if (room.windowCount > 0) {
                        productList.push({
                            product: austattung_produkt["tueren-und-fenstern"],
                            count: 1 * room.windowCount,
                            room: room.type
                        });
                        productList.push({
                            product: austattung_produkt["tueren-und-fenstern-kontakt"],
                            count: 2 * room.windowCount,
                            room: room.type
                        });
                        console.log('added', room.windowCount,'x',austattung_produkt["tueren-und-fenstern"], ' and 2 x', room.windowCount, austattung_produkt["tueren-und-fenstern-kontakt"])
                    }
                });
            });
        }
    }
    if (project.selectedEquipment["smart-haus-bedienstellen"] !== undefined
        && Boolean(project.selectedEquipment["smart-haus-bedienstellen"])
    ) {
        if (project.selectedEquipment["smart-haus-bedienstellen"] > 0) {
            productList.push({
                product: "BTLSCD1002",
                count: 1,
                room: getRoomForProduct("smart-haus-bedienstellen")
            });
            productList.push({
                product: "LS102KO5WW",
                count: 1,
                room: getRoomForProduct("smart-haus-bedienstellen")
            });
            productList.push({
                product: "LS981WW",
                count: 1,
                room: getRoomForProduct("smart-haus-bedienstellen")
            });
        }
    }
    console.log('project',project)
    let selectedSensorCombi = -1;
    if (
        project.selectedEquipment["puck-wind"] !== undefined && Boolean(project.selectedEquipment["puck-wind"]) && project.selectedEquipment["puck-wind"] > 0 &&
        (project.selectedEquipment["puck-sun"] === undefined || !Boolean(project.selectedEquipment["puck-sun"]) || project.selectedEquipment["puck-sun"] < 1) &&
        (project.selectedEquipment["puck-rain"] === undefined || !Boolean(project.selectedEquipment["puck-rain"]) || project.selectedEquipment["puck-rain"] < 1)
    ) { selectedSensorCombi = 0; }
    if (
        project.selectedEquipment["puck-sun"] !== undefined && Boolean(project.selectedEquipment["puck-sun"]) && project.selectedEquipment["puck-sun"] > 0 &&
        (project.selectedEquipment["puck-wind"] === undefined || !Boolean(project.selectedEquipment["puck-wind"]) || project.selectedEquipment["puck-wind"] < 1) &&
        (project.selectedEquipment["puck-rain"] === undefined || !Boolean(project.selectedEquipment["puck-rain"]) || project.selectedEquipment["puck-rain"] < 1)
    ) { selectedSensorCombi = 1; }
    if (
        project.selectedEquipment["puck-rain"] !== undefined && Boolean(project.selectedEquipment["puck-rain"]) && project.selectedEquipment["puck-rain"] > 0 &&
        (project.selectedEquipment["puck-wind"] === undefined || !Boolean(project.selectedEquipment["puck-wind"]) || project.selectedEquipment["puck-wind"] < 1) &&
        (project.selectedEquipment["puck-sun"] === undefined || !Boolean(project.selectedEquipment["puck-sun"]) || project.selectedEquipment["puck-sun"] < 1)
    ) { selectedSensorCombi = 2; }
    if (
        project.selectedEquipment["puck-wind"] !== undefined && Boolean(project.selectedEquipment["puck-wind"]) && project.selectedEquipment["puck-wind"] > 0 &&
        project.selectedEquipment["puck-sun"] !== undefined && Boolean(project.selectedEquipment["puck-sun"]) && project.selectedEquipment["puck-sun"] > 0 &&
        (project.selectedEquipment["puck-rain"] === undefined || !Boolean(project.selectedEquipment["puck-rain"]) || project.selectedEquipment["puck-rain"] < 1)
    ) { selectedSensorCombi = 3; }
    if (
        project.selectedEquipment["puck-wind"] !== undefined && Boolean(project.selectedEquipment["puck-wind"]) && project.selectedEquipment["puck-wind"] > 0 &&
        project.selectedEquipment["puck-rain"] !== undefined && Boolean(project.selectedEquipment["puck-rain"]) && project.selectedEquipment["puck-rain"] > 0 &&
        (project.selectedEquipment["puck-sun"] === undefined || !Boolean(project.selectedEquipment["puck-sun"]) || project.selectedEquipment["puck-sun"] < 1)
    ) { selectedSensorCombi = 4; }
    if (
        project.selectedEquipment["puck-sun"] !== undefined && Boolean(project.selectedEquipment["puck-sun"]) && project.selectedEquipment["puck-sun"] > 0 &&
        project.selectedEquipment["puck-rain"] !== undefined && Boolean(project.selectedEquipment["puck-rain"]) && project.selectedEquipment["puck-rain"] > 0 &&
        (project.selectedEquipment["puck-wind"] === undefined || !Boolean(project.selectedEquipment["puck-wind"]) || project.selectedEquipment["puck-wind"] < 1)
    ) { selectedSensorCombi = 5; }
    if (
        project.selectedEquipment["puck-sun"] !== undefined && Boolean(project.selectedEquipment["puck-sun"]) && project.selectedEquipment["puck-sun"] > 0 &&
        project.selectedEquipment["puck-rain"] !== undefined && Boolean(project.selectedEquipment["puck-rain"]) && project.selectedEquipment["puck-rain"] > 0 &&
        project.selectedEquipment["puck-wind"] !== undefined && Boolean(project.selectedEquipment["puck-wind"]) && project.selectedEquipment["puck-wind"] > 0
    ) { selectedSensorCombi = 6; }
    const sensorCombis = [
        ['windsensor','umsetzer_w','home-puck-jalousie'],
        ['sonnensensor','umsetzer_s-d','home-puck-jalousie'],
        ['regensensor_ums','home-puck-jalousie'],
        ['windsensor','sonnensensor','umsetzer-s-d-w','home-puck-jalousie'],
        ['windsensor','regensensor_ums','umsetzer_w','home-puck-jalousie'],
        ['sonnensensor','regensensor_ums','umsetzer_s-d','home-puck-jalousie'],
        ['windsensor','sonnensensor','regensensor_ums','umsetzer-s-d-w','home-puck-jalousie'],
    ];
    const sensorCombis_umbau = [
        ['windsensor','umsetzer-s-w','home-puck-jalousie'],
        ['sonnensensor','umsetzer-s-w','home-puck-jalousie'],
        ['regensensor_ums','home-puck-jalousie'],
        ['windsensor','sonnensensor','umsetzer-s-w','home-puck-jalousie'],
        ['windsensor','regensensor_ums','umsetzer-s-w','home-puck-jalousie'],
        ['sonnensensor','regensensor_ums','umsetzer_s-d','home-puck-jalousie'],
        ['windsensor','sonnensensor','regensensor_ums','umsetzer-s-w','home-puck-jalousie'],
    ];

    if (selectedSensorCombi >= 0) {
        (project.subProjectType === 'umbau' ? sensorCombis_umbau : sensorCombis)[selectedSensorCombi].forEach(ap => {
            productList.push({
                product: austattung_produkt[ap],
                count: 1,
                room: getRoomForProduct("puck-wind")
            });
        });
    }
    // console.log('produktlist', productList)
    const found = productList.filter(i => i.product === austattung_produkt['smart-haus-sprachsteuerung'])[0];
    if (found) {
        productList = [...productList.filter(i => i.product !== austattung_produkt['smart-haus-sprachsteuerung']), found];
        // console.log('CHANGED produktlist', productList)
    }

    return { productList, cProducts };
}
